export const countrys = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas (the)",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia (Plurinational State of)",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory (the)",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands (the)",
    "Central African Republic (the)",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands (the)",
    "Colombia",
    "Comoros (the)",
    "Congo (the Democratic Republic of the)",
    "Congo (the)",
    "Cook Islands (the)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czechia",
    "Côte d'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic (the)",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Falkland Islands (the) [Malvinas]",
    "Faroe Islands (the)",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories (the)",
    "Gabon",
    "Gambia (the)",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (the)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran (Islamic Republic of)",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic (the)",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands (the)",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia (Federated States of)",
    "Moldova (the Republic of)",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands (the)",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger (the)",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands (the)",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines (the)",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of North Macedonia",
    "Romania",
    "Russian Federation (the)",
    "Rwanda",
    "Réunion",
    "Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan (the)",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan (Province of China)",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands (the)",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates (the)",
    "United Kingdom of Great Britain and Northern Ireland (the)",
    "United States Minor Outlying Islands (the)",
    "United States of America (the)",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela (Bolivarian Republic of)",
    "Viet Nam",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands"
];

const countryList = [
    {
        label: "Afghanistan",
        value: "Afghanistan",
        name: "country"
    },
    {
        label: "Albania",
        value: "Albania",
        name: "country"
    },
    {
        label: "Algeria",
        value: "Algeria",
        name: "country"
    },
    {
        label: "American Samoa",
        value: "American Samoa",
        name: "country"
    },
    {
        label: "Andorra",
        value: "Andorra",
        name: "country"
    },
    {
        label: "Angola",
        value: "Angola",
        name: "country"
    },
    {
        label: "Anguilla",
        value: "Anguilla",
        name: "country"
    },
    {
        label: "Antarctica",
        value: "Antarctica",
        name: "country"
    },
    {
        label: "Antigua and Barbuda",
        value: "Antigua and Barbuda",
        name: "country"
    },
    {
        label: "Argentina",
        value: "Argentina",
        name: "country"
    },
    {
        label: "Armenia",
        value: "Armenia",
        name: "country"
    },
    {
        label: "Aruba",
        value: "Aruba",
        name: "country"
    },
    {
        label: "Australia",
        value: "Australia",
        name: "country"
    },
    {
        label: "Austria",
        value: "Austria",
        name: "country"
    },
    {
        label: "Azerbaijan",
        value: "Azerbaijan",
        name: "country"
    },
    {
        label: "Bahamas (the)",
        value: "Bahamas (the)",
        name: "country"
    },
    {
        label: "Bahrain",
        value: "Bahrain",
        name: "country"
    },
    {
        label: "Bangladesh",
        value: "Bangladesh",
        name: "country"
    },
    {
        label: "Barbados",
        value: "Barbados",
        name: "country"
    },
    {
        label: "Belarus",
        value: "Belarus",
        name: "country"
    },
    {
        label: "Belgium",
        value: "Belgium",
        name: "country"
    },
    {
        label: "Belize",
        value: "Belize",
        name: "country"
    },
    {
        label: "Benin",
        value: "Benin",
        name: "country"
    },
    {
        label: "Bermuda",
        value: "Bermuda",
        name: "country"
    },
    {
        label: "Bhutan",
        value: "Bhutan",
        name: "country"
    },
    {
        label: "Bolivia (Plurinational State of)",
        value: "Bolivia (Plurinational State of)",
        name: "country"
    },
    {
        label: "Bonaire, Sint Eustatius and Saba",
        value: "Bonaire, Sint Eustatius and Saba",
        name: "country"
    },
    {
        label: "Bosnia and Herzegovina",
        value: "Bosnia and Herzegovina",
        name: "country"
    },
    {
        label: "Botswana",
        value: "Botswana",
        name: "country"
    },
    {
        label: "Bouvet Island",
        value: "Bouvet Island",
        name: "country"
    },
    {
        label: "Brazil",
        value: "Brazil",
        name: "country"
    },
    {
        label: "British Indian Ocean Territory (the)",
        value: "British Indian Ocean Territory (the)",
        name: "country"
    },
    {
        label: "Brunei Darussalam",
        value: "Brunei Darussalam",
        name: "country"
    },
    {
        label: "Bulgaria",
        value: "Bulgaria",
        name: "country"
    },
    {
        label: "Burkina Faso",
        value: "Burkina Faso",
        name: "country"
    },
    {
        label: "Burundi",
        value: "Burundi",
        name: "country"
    },
    {
        label: "Cabo Verde",
        value: "Cabo Verde",
        name: "country"
    },
    {
        label: "Cambodia",
        value: "Cambodia",
        name: "country"
    },
    {
        label: "Cameroon",
        value: "Cameroon",
        name: "country"
    },
    {
        label: "Canada",
        value: "Canada",
        name: "country"
    },
    {
        label: "Cayman Islands (the)",
        value: "Cayman Islands (the)",
        name: "country"
    },
    {
        label: "Central African Republic (the)",
        value: "Central African Republic (the)",
        name: "country"
    },
    {
        label: "Chad",
        value: "Chad",
        name: "country"
    },
    {
        label: "Chile",
        value: "Chile",
        name: "country"
    },
    {
        label: "China",
        value: "China",
        name: "country"
    },
    {
        label: "Christmas Island",
        value: "Christmas Island",
        name: "country"
    },
    {
        label: "Cocos (Keeling) Islands (the)",
        value: "Cocos (Keeling) Islands (the)",
        name: "country"
    },
    {
        label: "Colombia",
        value: "Colombia",
        name: "country"
    },
    {
        label: "Comoros (the)",
        value: "Comoros (the)",
        name: "country"
    },
    {
        label: "Congo (the Democratic Republic of the)",
        value: "Congo (the Democratic Republic of the)",
        name: "country"
    },
    {
        label: "Congo (the)",
        value: "Congo (the)",
        name: "country"
    },
    {
        label: "Cook Islands (the)",
        value: "Cook Islands (the)",
        name: "country"
    },
    {
        label: "Costa Rica",
        value: "Costa Rica",
        name: "country"
    },
    {
        label: "Croatia",
        value: "Croatia",
        name: "country"
    },
    {
        label: "Cuba",
        value: "Cuba",
        name: "country"
    },
    {
        label: "Curaçao",
        value: "Curaçao",
        name: "country"
    },
    {
        label: "Cyprus",
        value: "Cyprus",
        name: "country"
    },
    {
        label: "Czechia",
        value: "Czechia",
        name: "country"
    },
    {
        label: "Côte d'Ivoire",
        value: "Côte d'Ivoire",
        name: "country"
    },
    {
        label: "Denmark",
        value: "Denmark",
        name: "country"
    },
    {
        label: "Djibouti",
        value: "Djibouti",
        name: "country"
    },
    {
        label: "Dominica",
        value: "Dominica",
        name: "country"
    },
    {
        label: "Dominican Republic (the)",
        value: "Dominican Republic (the)",
        name: "country"
    },
    {
        label: "Ecuador",
        value: "Ecuador",
        name: "country"
    },
    {
        label: "Egypt",
        value: "Egypt",
        name: "country"
    },
    {
        label: "El Salvador",
        value: "El Salvador",
        name: "country"
    },
    {
        label: "Equatorial Guinea",
        value: "Equatorial Guinea",
        name: "country"
    },
    {
        label: "Eritrea",
        value: "Eritrea",
        name: "country"
    },
    {
        label: "Estonia",
        value: "Estonia",
        name: "country"
    },
    {
        label: "Eswatini",
        value: "Eswatini",
        name: "country"
    },
    {
        label: "Ethiopia",
        value: "Ethiopia",
        name: "country"
    },
    {
        label: "Falkland Islands (the) [Malvinas]",
        value: "Falkland Islands (the) [Malvinas]",
        name: "country"
    },
    {
        label: "Faroe Islands (the)",
        value: "Faroe Islands (the)",
        name: "country"
    },
    {
        label: "Fiji",
        value: "Fiji",
        name: "country"
    },
    {
        label: "Finland",
        value: "Finland",
        name: "country"
    },
    {
        label: "France",
        value: "France",
        name: "country"
    },
    {
        label: "French Guiana",
        value: "French Guiana",
        name: "country"
    },
    {
        label: "French Polynesia",
        value: "French Polynesia",
        name: "country"
    },
    {
        label: "French Southern Territories (the)",
        value: "French Southern Territories (the)",
        name: "country"
    },
    {
        label: "Gabon",
        value: "Gabon",
        name: "country"
    },
    {
        label: "Gambia (the)",
        value: "Gambia (the)",
        name: "country"
    },
    {
        label: "Georgia",
        value: "Georgia",
        name: "country"
    },
    {
        label: "Germany",
        value: "Germany",
        name: "country"
    },
    {
        label: "Ghana",
        value: "Ghana",
        name: "country"
    },
    {
        label: "Gibraltar",
        value: "Gibraltar",
        name: "country"
    },
    {
        label: "Greece",
        value: "Greece",
        name: "country"
    },
    {
        label: "Greenland",
        value: "Greenland",
        name: "country"
    },
    {
        label: "Grenada",
        value: "Grenada",
        name: "country"
    },
    {
        label: "Guadeloupe",
        value: "Guadeloupe",
        name: "country"
    },
    {
        label: "Guam",
        value: "Guam",
        name: "country"
    },
    {
        label: "Guatemala",
        value: "Guatemala",
        name: "country"
    },
    {
        label: "Guernsey",
        value: "Guernsey",
        name: "country"
    },
    {
        label: "Guinea",
        value: "Guinea",
        name: "country"
    },
    {
        label: "Guinea-Bissau",
        value: "Guinea-Bissau",
        name: "country"
    },
    {
        label: "Guyana",
        value: "Guyana",
        name: "country"
    },
    {
        label: "Haiti",
        value: "Haiti",
        name: "country"
    },
    {
        label: "Heard Island and McDonald Islands",
        value: "Heard Island and McDonald Islands",
        name: "country"
    },
    {
        label: "Holy See (the)",
        value: "Holy See (the)",
        name: "country"
    },
    {
        label: "Honduras",
        value: "Honduras",
        name: "country"
    },
    {
        label: "Hong Kong",
        value: "Hong Kong",
        name: "country"
    },
    {
        label: "Hungary",
        value: "Hungary",
        name: "country"
    },
    {
        label: "Iceland",
        value: "Iceland",
        name: "country"
    },
    {
        label: "India",
        value: "India",
        name: "country"
    },
    {
        label: "Indonesia",
        value: "Indonesia",
        name: "country"
    },
    {
        label: "Iran (Islamic Republic of)",
        value: "Iran (Islamic Republic of)",
        name: "country"
    },
    {
        label: "Iraq",
        value: "Iraq",
        name: "country"
    },
    {
        label: "Ireland",
        value: "Ireland",
        name: "country"
    },
    {
        label: "Isle of Man",
        value: "Isle of Man",
        name: "country"
    },
    {
        label: "Israel",
        value: "Israel",
        name: "country"
    },
    {
        label: "Italy",
        value: "Italy",
        name: "country"
    },
    {
        label: "Jamaica",
        value: "Jamaica",
        name: "country"
    },
    {
        label: "Japan",
        value: "Japan",
        name: "country"
    },
    {
        label: "Jersey",
        value: "Jersey",
        name: "country"
    },
    {
        label: "Jordan",
        value: "Jordan",
        name: "country"
    },
    {
        label: "Kazakhstan",
        value: "Kazakhstan",
        name: "country"
    },
    {
        label: "Kenya",
        value: "Kenya",
        name: "country"
    },
    {
        label: "Kiribati",
        value: "Kiribati",
        name: "country"
    },
    {
        label: "Korea (the Democratic People's Republic of)",
        value: "Korea (the Democratic People's Republic of)",
        name: "country"
    },
    {
        label: "Korea (the Republic of)",
        value: "Korea (the Republic of)",
        name: "country"
    },
    {
        label: "Kuwait",
        value: "Kuwait",
        name: "country"
    },
    {
        label: "Kyrgyzstan",
        value: "Kyrgyzstan",
        name: "country"
    },
    {
        label: "Lao People's Democratic Republic (the)",
        value: "Lao People's Democratic Republic (the)",
        name: "country"
    },
    {
        label: "Latvia",
        value: "Latvia",
        name: "country"
    },
    {
        label: "Lebanon",
        value: "Lebanon",
        name: "country"
    },
    {
        label: "Lesotho",
        value: "Lesotho",
        name: "country"
    },
    {
        label: "Liberia",
        value: "Liberia",
        name: "country"
    },
    {
        label: "Libya",
        value: "Libya",
        name: "country"
    },
    {
        label: "Liechtenstein",
        value: "Liechtenstein",
        name: "country"
    },
    {
        label: "Lithuania",
        value: "Lithuania",
        name: "country"
    },
    {
        label: "Luxembourg",
        value: "Luxembourg",
        name: "country"
    },
    {
        label: "Macao",
        value: "Macao",
        name: "country"
    },
    {
        label: "Madagascar",
        value: "Madagascar",
        name: "country"
    },
    {
        label: "Malawi",
        value: "Malawi",
        name: "country"
    },
    {
        label: "Malaysia",
        value: "Malaysia",
        name: "country"
    },
    {
        label: "Maldives",
        value: "Maldives",
        name: "country"
    },
    {
        label: "Mali",
        value: "Mali",
        name: "country"
    },
    {
        label: "Malta",
        value: "Malta",
        name: "country"
    },
    {
        label: "Marshall Islands (the)",
        value: "Marshall Islands (the)",
        name: "country"
    },
    {
        label: "Martinique",
        value: "Martinique",
        name: "country"
    },
    {
        label: "Mauritania",
        value: "Mauritania",
        name: "country"
    },
    {
        label: "Mauritius",
        value: "Mauritius",
        name: "country"
    },
    {
        label: "Mayotte",
        value: "Mayotte",
        name: "country"
    },
    {
        label: "Mexico",
        value: "Mexico",
        name: "country"
    },
    {
        label: "Micronesia (Federated States of)",
        value: "Micronesia (Federated States of)",
        name: "country"
    },
    {
        label: "Moldova (the Republic of)",
        value: "Moldova (the Republic of)",
        name: "country"
    },
    {
        label: "Monaco",
        value: "Monaco",
        name: "country"
    },
    {
        label: "Mongolia",
        value: "Mongolia",
        name: "country"
    },
    {
        label: "Montenegro",
        value: "Montenegro",
        name: "country"
    },
    {
        label: "Montserrat",
        value: "Montserrat",
        name: "country"
    },
    {
        label: "Morocco",
        value: "Morocco",
        name: "country"
    },
    {
        label: "Mozambique",
        value: "Mozambique",
        name: "country"
    },
    {
        label: "Myanmar",
        value: "Myanmar",
        name: "country"
    },
    {
        label: "Namibia",
        value: "Namibia",
        name: "country"
    },
    {
        label: "Nauru",
        value: "Nauru",
        name: "country"
    },
    {
        label: "Nepal",
        value: "Nepal",
        name: "country"
    },
    {
        label: "Netherlands (the)",
        value: "Netherlands (the)",
        name: "country"
    },
    {
        label: "New Caledonia",
        value: "New Caledonia",
        name: "country"
    },
    {
        label: "New Zealand",
        value: "New Zealand",
        name: "country"
    },
    {
        label: "Nicaragua",
        value: "Nicaragua",
        name: "country"
    },
    {
        label: "Niger (the)",
        value: "Niger (the)",
        name: "country"
    },
    {
        label: "Nigeria",
        value: "Nigeria",
        name: "country"
    },
    {
        label: "Niue",
        value: "Niue",
        name: "country"
    },
    {
        label: "Norfolk Island",
        value: "Norfolk Island",
        name: "country"
    },
    {
        label: "Northern Mariana Islands (the)",
        value: "Northern Mariana Islands (the)",
        name: "country"
    },
    {
        label: "Norway",
        value: "Norway",
        name: "country"
    },
    {
        label: "Oman",
        value: "Oman",
        name: "country"
    },
    {
        label: "Pakistan",
        value: "Pakistan",
        name: "country"
    },
    {
        label: "Palau",
        value: "Palau",
        name: "country"
    },
    {
        label: "Palestine, State of",
        value: "Palestine, State of",
        name: "country"
    },
    {
        label: "Panama",
        value: "Panama",
        name: "country"
    },
    {
        label: "Papua New Guinea",
        value: "Papua New Guinea",
        name: "country"
    },
    {
        label: "Paraguay",
        value: "Paraguay",
        name: "country"
    },
    {
        label: "Peru",
        value: "Peru",
        name: "country"
    },
    {
        label: "Philippines (the)",
        value: "Philippines (the)",
        name: "country"
    },
    {
        label: "Pitcairn",
        value: "Pitcairn",
        name: "country"
    },
    {
        label: "Poland",
        value: "Poland",
        name: "country"
    },
    {
        label: "Portugal",
        value: "Portugal",
        name: "country"
    },
    {
        label: "Puerto Rico",
        value: "Puerto Rico",
        name: "country"
    },
    {
        label: "Qatar",
        value: "Qatar",
        name: "country"
    },
    {
        label: "Republic of North Macedonia",
        value: "Republic of North Macedonia",
        name: "country"
    },
    {
        label: "Romania",
        value: "Romania",
        name: "country"
    },
    {
        label: "Russian Federation (the)",
        value: "Russian Federation (the)",
        name: "country"
    },
    {
        label: "Rwanda",
        value: "Rwanda",
        name: "country"
    },
    {
        label: "Réunion",
        value: "Réunion",
        name: "country"
    },
    {
        label: "Saint Barthélemy",
        value: "Saint Barthélemy",
        name: "country"
    },
    {
        label: "Saint Helena, Ascension and Tristan da Cunha",
        value: "Saint Helena, Ascension and Tristan da Cunha",
        name: "country"
    },
    {
        label: "Saint Kitts and Nevis",
        value: "Saint Kitts and Nevis",
        name: "country"
    },
    {
        label: "Saint Lucia",
        value: "Saint Lucia",
        name: "country"
    },
    {
        label: "Saint Martin (French part)",
        value: "Saint Martin (French part)",
        name: "country"
    },
    {
        label: "Saint Pierre and Miquelon",
        value: "Saint Pierre and Miquelon",
        name: "country"
    },
    {
        label: "Saint Vincent and the Grenadines",
        value: "Saint Vincent and the Grenadines",
        name: "country"
    },
    {
        label: "Samoa",
        value: "Samoa",
        name: "country"
    },
    {
        label: "San Marino",
        value: "San Marino",
        name: "country"
    },
    {
        label: "Sao Tome and Principe",
        value: "Sao Tome and Principe",
        name: "country"
    },
    {
        label: "Saudi Arabia",
        value: "Saudi Arabia",
        name: "country"
    },
    {
        label: "Senegal",
        value: "Senegal",
        name: "country"
    },
    {
        label: "Serbia",
        value: "Serbia",
        name: "country"
    },
    {
        label: "Seychelles",
        value: "Seychelles",
        name: "country"
    },
    {
        label: "Sierra Leone",
        value: "Sierra Leone",
        name: "country"
    },
    {
        label: "Singapore",
        value: "Singapore",
        name: "country"
    },
    {
        label: "Sint Maarten (Dutch part)",
        value: "Sint Maarten (Dutch part)",
        name: "country"
    },
    {
        label: "Slovakia",
        value: "Slovakia",
        name: "country"
    },
    {
        label: "Slovenia",
        value: "Slovenia",
        name: "country"
    },
    {
        label: "Solomon Islands",
        value: "Solomon Islands",
        name: "country"
    },
    {
        label: "Somalia",
        value: "Somalia",
        name: "country"
    },
    {
        label: "South Africa",
        value: "South Africa",
        name: "country"
    },
    {
        label: "South Georgia and the South Sandwich Islands",
        value: "South Georgia and the South Sandwich Islands",
        name: "country"
    },
    {
        label: "South Sudan",
        value: "South Sudan",
        name: "country"
    },
    {
        label: "Spain",
        value: "Spain",
        name: "country"
    },
    {
        label: "Sri Lanka",
        value: "Sri Lanka",
        name: "country"
    },
    {
        label: "Sudan (the)",
        value: "Sudan (the)",
        name: "country"
    },
    {
        label: "Suriname",
        value: "Suriname",
        name: "country"
    },
    {
        label: "Svalbard and Jan Mayen",
        value: "Svalbard and Jan Mayen",
        name: "country"
    },
    {
        label: "Sweden",
        value: "Sweden",
        name: "country"
    },
    {
        label: "Switzerland",
        value: "Switzerland",
        name: "country"
    },
    {
        label: "Syrian Arab Republic",
        value: "Syrian Arab Republic",
        name: "country"
    },
    {
        label: "Taiwan (Province of China)",
        value: "Taiwan (Province of China)",
        name: "country"
    },
    {
        label: "Tajikistan",
        value: "Tajikistan",
        name: "country"
    },
    {
        label: "Tanzania, United Republic of",
        value: "Tanzania, United Republic of",
        name: "country"
    },
    {
        label: "Thailand",
        value: "Thailand",
        name: "country"
    },
    {
        label: "Timor-Leste",
        value: "Timor-Leste",
        name: "country"
    },
    {
        label: "Togo",
        value: "Togo",
        name: "country"
    },
    {
        label: "Tokelau",
        value: "Tokelau",
        name: "country"
    },
    {
        label: "Tonga",
        value: "Tonga",
        name: "country"
    },
    {
        label: "Trinidad and Tobago",
        value: "Trinidad and Tobago",
        name: "country"
    },
    {
        label: "Tunisia",
        value: "Tunisia",
        name: "country"
    },
    {
        label: "Turkey",
        value: "Turkey",
        name: "country"
    },
    {
        label: "Turkmenistan",
        value: "Turkmenistan",
        name: "country"
    },
    {
        label: "Turks and Caicos Islands (the)",
        value: "Turks and Caicos Islands (the)",
        name: "country"
    },
    {
        label: "Tuvalu",
        value: "Tuvalu",
        name: "country"
    },
    {
        label: "Uganda",
        value: "Uganda",
        name: "country"
    },
    {
        label: "Ukraine",
        value: "Ukraine",
        name: "country"
    },
    {
        label: "United Arab Emirates (the)",
        value: "United Arab Emirates (the)",
        name: "country"
    },
    {
        label: "United Kingdom of Great Britain and Northern Ireland (the)",
        value: "United Kingdom of Great Britain and Northern Ireland (the)",
        name: "country"
    },
    {
        label: "United States Minor Outlying Islands (the)",
        value: "United States Minor Outlying Islands (the)",
        name: "country"
    },
    {
        label: "United States of America (the)",
        value: "United States of America (the)",
        name: "country"
    },
    {
        label: "Uruguay",
        value: "Uruguay",
        name: "country"
    },
    {
        label: "Uzbekistan",
        value: "Uzbekistan",
        name: "country"
    },
    {
        label: "Vanuatu",
        value: "Vanuatu",
        name: "country"
    },
    {
        label: "Venezuela (Bolivarian Republic of)",
        value: "Venezuela (Bolivarian Republic of)",
        name: "country"
    },
    {
        label: "Viet Nam",
        value: "Viet Nam",
        name: "country"
    },
    {
        label: "Virgin Islands (British)",
        value: "Virgin Islands (British)",
        name: "country"
    },
    {
        label: "Virgin Islands (U.S.)",
        value: "Virgin Islands (U.S.)",
        name: "country"
    },
    {
        label: "Wallis and Futuna",
        value: "Wallis and Futuna",
        name: "country"
    },
    {
        label: "Western Sahara",
        value: "Western Sahara",
        name: "country"
    },
    {
        label: "Yemen",
        value: "Yemen",
        name: "country"
    },
    {
        label: "Zambia",
        value: "Zambia",
        name: "country"
    },
    {
        label: "Zimbabwe",
        value: "Zimbabwe",
        name: "country"
    },
    {
        label: "Åland Islands",
        value: "Åland Islands",
        name: "country"
    }
];

export default countryList;
